import { ToolkitListingID, ToolkitListingIDParsed } from '@aloft/toolkit-shared';

import { z } from 'zod';

const _schReferenceViewPropertyID = z.string().brand('ReferenceViewPropertyID');
type ReferenceViewPropertyID = z.infer<typeof _schReferenceViewPropertyID>;
export type ReferenceViewPropertyIDParsed =
  | {
      type: 'subject';
    }
  | {
      type: 'comparable';
      compID: string;
    };

export type ReferenceViewID = ReferenceViewPropertyID | ToolkitListingID;
export type ReferenceViewIDParsed = ReferenceViewPropertyIDParsed | ToolkitListingIDParsed;
